import { AppIcon, type IconDefinition } from '@/components/ui/app-icon';
import type { EmptyStateIcon } from './empty-state';

/**
 * Wraps an icon from `@/lib/icons` so `EmptyState`
 * can size it through `className`. Call it at module scope, never in a render,
 * so the component identity is stable.
 */
export function emptyStateIcon(icon: IconDefinition): EmptyStateIcon {
  const Glyph = ({ className }: { className?: string }) => (
    <AppIcon icon={icon} className={className} />
  );
  Glyph.displayName = `EmptyStateIcon(${icon.name})`;
  return Glyph;
}
